import { History } from "history";
import { connectRouter } from "connected-react-router";

import searchPageData from "@Pages/Search/data/searchPageReducer";
import smartFilterData from "@Pages/Search/components/FilterSection/components/SmartFilters/smartFilterReducer";
import leadFormModal from "@Components/LeadFormModal/data/leadFormReducer";
import propertyPageData from "@Pages/PropertyPage/data/propertyPageReducer";
import videoPageData from "@Pages/VideoPage/data/videoPageReducer";
import chatBotReducer from "@Pages/PropertyPage/components/ZendeskChat/ChatBotReducer";
import activityPageData from "@Pages/Activity/data/activityPageReducer";
import amberPlusPageData from "@Pages/AmberPlus/data/amberPlusPageReducer";

import appData from "@App/appReducer";
import whitelabelData from "@App/whiteLabelReducer";
import iframeData from "@App/iframeReducer";
import loginData from "@Components/Login/loginReducer";
import toastData from "@Components/ToastNotification/toastReducer";
import searchMap from "@Pages/Search/components/DesktopMapSection/data/mapSectionReducer";
import bookFormData from "@Pages/BookForm/data/bookFormReducer";
import userHistory from "@App/userHistoryReducer";
import amberPlusCategoriesPageData from "@Pages/PlusCategories/data/plusCategoriesPageReducer";
import blogPageData from "@Pages/Blog/BlogPost/data/blogPageReducer";
import blogHomeData from "@Pages/Blog/BlogHome/data/blogHomeReducer";
import newsPageData from "@Pages/News/NewsPost/data/newsPageReducer";
import newsHomeData from "@Pages/News/NewsHome/data/newsHomeReducer";
import universityPageData from "@Pages/UniversityPage/data/universityPageReducer";
import bookingDetailsData from "@Pages/BookingDetails/data/bookingDetailsReducer";
import examsPageData from "@Pages/Exams/ExamsPost/data/examsPageReducer";
import examsHomeData from "@Pages/Exams/data/examsHomeReducer";
import amberPlusCrossPageData from "@Pages/AmberPlusCross/data/amberPlusCrossReducer";

// Use inferred return type for making correctly Redux types
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (history: History) => ({
  searchPageData,
  smartFilterData,
  appData,
  leadFormModal,
  searchMap,
  loginData,
  toastData,
  propertyPageData,
  videoPageData,
  bookFormData,
  activityPageData,
  amberPlusPageData,
  userHistory,
  chatBotReducer,
  amberPlusCategoriesPageData,
  blogPageData,
  blogHomeData,
  newsPageData,
  newsHomeData,
  universityPageData,
  bookingDetailsData,
  examsPageData,
  examsHomeData,
  whitelabelData,
  amberPlusCrossPageData,
  iframeData,
  router: connectRouter(history) as any,
  // Register more reducers...
});
